// extracted by mini-css-extract-plugin
module.exports = {"container":"noAppointmentCard_container__GtiyI card_card__JwU2R","bold":"noAppointmentCard_bold__1B5rL","button":"noAppointmentCard_button__33arJ"};